/**
 * 模块如果被修改，则不允许保存
 * 思路，先平铺，然后根据tag获取节点类型，然后根据节点类型进行处理成对应的数据，最后diff得到更改，新增，删除的节点
 *  */
export function buildSaveNodes(startData, endData, saveNodes) {
  const startNodes = [];
  const endNodes = [];
  readNodes([startData], startNodes);
  readNodes([endData], endNodes);
  // console.log(startData, endData);
  // console.log(startNodes, endNodes);
  return diffCase(startNodes, endNodes);
}

function diffCase(startNodes, endNodes) {
  // 比较两个数组，找出新增、删除、修改的节点
  // 新增的节点
  const addedNodes = endNodes.filter(node => !startNodes.some(startNode => startNode.uid === node.uid));
  // 删除的节点
  const deletedNodes = startNodes.filter(node => !endNodes.some(endNode => endNode.uid === node.uid));
  // 修改的节点
  const changedNodes = endNodes.filter(startNode => startNodes.some(endNode => endNode.uid === startNode.uid && JSON.stringify(startNode) !== JSON.stringify(endNode)));

  // console.log('新增的节点', addedNodes);
  // console.log('删除的节点', deletedNodes);
  // console.log('修改的节点', changedNodes);

  return {
    addedNodes,
    deletedNodes,
    changedNodes
  };
}

// 先进行平铺
function readNodes(nodes = [], arr = [], pNode) {
  for (const node of nodes) {
    if (getNodeType(node) === '模块') {
      const _data = getModleData(node, pNode);
      _data.type = 'module';
      arr.push(_data);
      if (node.children && node.children.length) {
        readNodes(node.children, arr, node);
      }
    } else if (getNodeType(node) === '用例') {
      const _data = getCaseNodeData(node, pNode);
      _data.type = 'case';
      arr.push(_data);
    }
  }
  return arr;
}

export function getNodeType(node) {
  // 根据tag获取，有模块、用例-前置条件，步骤，预期结果
  if (!node || !node.data) return '';
  const { tag } = node.data;
  // [{text: '模块', style: {…}}]
  if (tag && Array.isArray(tag)) {
    return tag[0].text;
  }
  return '';
}
function getModleData(node, pNode) {
  const nodeData = node.data;
  const _data = nodeData.nodeData || {
    name: nodeData.text,
    title: nodeData.text
  };
  _data.uid = nodeData.uid || '';
  if (nodeData.nodeData) {
    _data.name = nodeData.text;
    _data.title = nodeData.text;
  }
  return _data;
}

function getCaseNodeData(node, pNode) {
  let pId = 0;
  let pKey = '';
  if (pNode) {
    if (pNode.data) {
      pKey = pNode.data.uid || '';
    }
    if (pNode.data && pNode.data.nodeData) {
      pId = pNode.data.nodeData.id || 0;
    }
  } else {
    pId = 0;
  }
  const nodeData = node.data;
  const _data = nodeData.nodeData || {
    name: nodeData.text,
    title: nodeData.text,
    module_id: pId,
    change_type: 'add'
  };
  _data.uid = nodeData.uid || '';
  if (nodeData.nodeData) {
    _data.name = nodeData.text;
    _data.title = nodeData.text;
  }
  _data.module_id = pId;
  const steps = [];
  if (node.children && node.children.length > 0) {
    // 构建步骤
    for (let index = 0; index < node.children.length; index++) {
      const element = node.children[index];
      if (index === 0 && element && element.data && element.data.tag && element.data.tag.length > 0 && element.data.tag[0].text === '前置条件') {
        _data.precondition = element.data.text;
      } else {
        let step = '';
        let result = '';
        const images = [];
        if (element.data) {
          step = element.data.text || '';
        }

        if (element.children && element.children.length > 0) {
          const resultNode = element.children[0];
          result = resultNode.data.text || '';
          if (resultNode.children && resultNode.children.length > 0) {
            resultNode.children.forEach(child => {
              if (child.data.nodeData) {
                child.data.nodeData.url = child.data.image;
                images.push(child.data.nodeData);
              } else if (child.data.image) {
                images.push({
                  url: child.data.image,
                  name: child.data.text,
                  response: '成功',
                  status: 'done',
                  uid: Date.now() + Math.random() * 1000000
                });
              }
            });
          }
        }

        // 步骤
        steps.push({
          step: step,
          result: result,
          images: images
        });
      }
    }
  }
  _data.steps = steps;
  return _data;
}
